// English pluralisation, first-match-wins over an ordered rule table. Lifted out of the saas-web
// landing pages so `i18n.pluralise` can use it too — the two had drifted, and the simpler one was
// getting words like "Saturday" and "box" wrong.
//
// Order matters: the last rule is the catch-all "add an s", so anything more specific must sit above
// it. Insertion order is the iteration order for string keys, which is what makes that work.
const pluralRules: Record<string, string> = {
  '(quiz)$': '$1zes',
  '^(ox)$': '$1en',
  '([m|l])ouse$': '$1ice',
  '(matr|vert|ind)(ix|ex)$': '$1ices',
  '(x|ch|ss|sh)$': '$1es',
  // A consonant before the y becomes -ies (city → cities); a vowel keeps it (day → days).
  '([^aeiouy]|qu)y$': '$1ies',
  '(hive)$': '$1s',
  '(kni|wi|li)fe$': '$1ves',
  '(ca|ha|e|wo)lf$': '$1lves',
  '(sca|dwa|wha)rf$': '$1rves',
  '(shea|lea|loa|thie)f$': '$1ves',
  'sis$': 'ses',
  '([ti])um$': '$1a',
  '(tomat|potat|ech|her|vet)o$': '$1oes',
  '(bu)s$': '$1ses',
  '(alias)$': '$1es',
  '(octop)us$': '$1i',
  '(ax|test)is$': '$1es',
  '(series|species|news)$': '$1',
  '(s)$': '$1es',
  '$': 's',
}

/** Pluralises an English word. Pass the count to leave it alone when there is exactly one. */
export function plural(word: string, amount?: number): string {
  if (amount !== undefined && amount === 1) {
    return word
  }

  for (const rule in pluralRules) {
    const pattern = new RegExp(rule, 'i')
    if (pattern.test(word)) {
      return word.replace(pattern, pluralRules[rule] as string)
    }
  }

  return word
}

export default plural
